var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswoed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 143,
    width: 292,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72 51c2 0 3-2 4-4l4-4 4-2 2-3 1-3c0-2 0-5 2-7l2-4-2-4-4-2h-5l-8-3-6 1c-3 1-4 4-5 7l-3 8-3 10 2 5c3 6 9 5 10 5z",
    fill: "#e7655b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 99 1-8c0-2 2-2 3-2l7 3-3 7-4-2-2 3c-1 1-3 0-2-1",
    fill: "#f8b380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 99c-1 1 1 2 2 1l2-3v-1c0-2 0-5 2-6l-2-1c-1 0-3 0-3 2z",
    fill: "#bdbebd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119 58c-12 6-26 6-39 6 1-2 3-5 3-8 12 1 23-1 34-3l4-3 2-1 3 1v1l-1 3-2 3h-1v2h-2zm-84 16c6-1 12-3 17-6l11-7-6-6c-22 17-27 15-30 15l-3 3 2 3 4-1 3 1v1l1-1zm35-26c1 4-5 4-2 7 3 2 7 1 7 0 0-2-2-4 0-5z",
    fill: "#f8b380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 66c4-3 5-8 6-12l-9-1",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74 81c-14 2-22-6-22-6 4-3 9-9 9-14l-5-7 6-1h5l9 1c3 8 4 10 3 13l-5 8z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52 75s-11 8-17 22l-23-5-3 7c3 2 19 10 34 12 7-4 12-9 15-14 0 0-1 6 5 17l-2 17 8 1c10-20 9-42 4-53",
    fill: "#00c6b6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m63 88c-4 10-13 19-20 23",
    stroke: "#178377",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 67-1 1-1 1 2 4 1 1h1",
    stroke: "#f8db62",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 23-2 2-11 6-4 5c0 7 5 13 12 14 5 1 9-2 10-7l1-5c1-6-2-11-6-15m-9 119h-9l-2-2 2-9 8 1-2 6h1l3 2c1 1 0 2-1 2",
    fill: "#f8b380",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 142c1 0 2-1 1-2l-3-2h-8l-1 2 2 2z",
    fill: "#bdbebd",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134 60s38 16 50-6c4-7 2-18-3-20-10-3-13 31 8 29 10-1 23-4 40-22",
    stroke: "#231f20",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 15 25 42c2 2 5 2 6 0l35-56-64 9c-2 0-4 3-2 5",
    fill: "#7e9cf1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 1-64 9c-2 0-4 3-2 5l2 3z",
    fill: "white",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267 7-26 5a1 1 0 1 1 0-2l26-4h1z",
    fill: "#e2e6e7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283 7-48 25v15l7-4-3-6z",
    fill: "#587ccb",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244 27-4-7 13-4 3 5",
    fill: "white",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 16 12-5m-10 7 6-3m-15 21 10-9m-9 11 10-9m-5 16 9-11m-8 13 9-11m-7 13 5-7m-12-2 7-7",
    stroke: "#587ccb",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229 13a1 1 0 1 1 -2-1 1 1 0 0 1 2 1",
    fill: "#e7655b",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 12a1 1 0 1 1 -2 0 1 1 0 0 1 2 0",
    fill: "#f8de70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 12a1 1 0 1 1 -2-1 1 1 0 0 1 2 1",
    fill: "#00c6b6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237 11h1m-1 0h-1l1 1",
    stroke: "#bdbebd",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263 25 7 9 7-13-4-4z",
    fill: "white",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 47 4-10 3 5z",
    fill: "#587ccb",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 1-64 9",
    stroke: "#aeaeae",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235 46 4-9 6-4",
    stroke: "#376498",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 54 1 2 3-1 3 2 1-2",
    stroke: "#c0bebf",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 55v4l-1 2c0 3-2 9-4 11l-1 5m12-18c2 4 2 6 1 8l-5 8",
    stroke: "#c0bebf",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 79c2 1 5 1 7-1l2-2m16 4 1 2 1 1",
    stroke: "#178377",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 97 1 1m-1 0v1m64 40 1-2m0 2 1-1",
    stroke: "darkgrey",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 131 8 1m-8-3 8 2m-57-39-3 7m5-7-2 6",
    stroke: "#178377",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66 46c-3-3 4-5 5-7 2-4 1-10 5-12l7-2-5-4-17 14 2 11zm-65-9v3c5 10 17 19 22 5 9-25 15-1 24-18 4-8 8-8 18-1l2-2c-5-5-11-9-18-10-12-4 0 15-15 10-27-8-18 16-29 14-1 0-3-2-4-1",
    fill: "#e7655b",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 142h47",
    stroke: "#676867",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswoed);
export default __webpack_public_path__ + "static/media/passwoed.de6311b7fe46cdb4bd72a8ce8c8be1c5.svg";
export { ForwardRef as ReactComponent };